// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lYail","imageContainer":"styles_imageContainer__Tnr1J","image":"styles_image__De5Nf","hints":"styles_hints__2hOmG","action":"styles_action__pmuhK"};